import { SlotGameType1_2 } from "../SlotGameType1_2";
export class LuckyFire20_2 extends SlotGameType1_2{}	